var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Ski Trail Rating Symbols - Double Black Diamond",
    viewBox: "0 0 599 599",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "diamond_left",
    fill: "#000",
    d: "M 155,560 L 290,300 L 155,40 L 20,300 L 155,560 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "diamond_right",
    fill: "#000",
    d: "M 445,40 L 580,300 L 445,560 L 310,300 L 445,40 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleblack);
export default __webpack_public_path__ + "static/media/doubleblack.313e0cb29e36edd9b22ed4f2451f8335.svg";
export { ForwardRef as ReactComponent };